export class ProductionDetails{
	static init() {
		ProductionDetails.moveDateBox();
		ProductionDetails.countMedia();
	}

	private static moveDateBox(){
		let leftContainer = document.getElementsByClassName("_detailsImage").item(0);
		let rightContainer = document.getElementsByClassName("_detailsEntries").item(0);
		if(leftContainer !== null && rightContainer !== null){
			let dateBoxes = leftContainer.getElementsByClassName("sshgWidget_dates");
			for(let i = 0; i < dateBoxes.length; i++){
				rightContainer.appendChild(dateBoxes.item(i));
			}
		}

	}

	private static countMedia(){
		let mediaElements = document.querySelectorAll('._mobileDetailsImage > div');
		if(mediaElements.length < 3){
			mediaElements[0].classList.add('hide');
		}
	}

	
}